<template>
  <ProductionOrder />
</template>

<script>
import ProductionOrder from "../../components/ProductionOrder";
export default {
  components: {
    ProductionOrder,
  },
};
</script>